import { Capacitor } from '@capacitor/core';

import prizesPng from '/img/contract/prizes.png';
import prizesWebp from '/img/contract/prizes.webp';
import prizesNoUsdPng from '/img/contract/prizes-no-usd.png';
import prizesNoUsdWebp from '/img/contract/prizes-no-usd.webp';

// Prizes around the fortune wheel; the App Store / Play build has no dollar
// coin among them.
const prizesImage = Capacitor.isNativePlatform()
  ? { png: prizesNoUsdPng, webp: prizesNoUsdWebp }
  : { png: prizesPng, webp: prizesWebp };

export { prizesImage };
